import { createRouter, createWebHistory } from 'vue-router';
import authMiddleware from '~/middleware/auth-organization-context';
import { authGuard } from '@auth0/auth0-vue';
import Conversation from '~/pages/conversation';
import Callback from '~/pages/callback';
import Dashboard from '~/pages/dashboard';
import { Routes } from '~/constants/routes';
import Login from '~/pages/login';
import Home from '~/pages/home';
import Error from '~/pages/error';
import AuthoringConversation from '~/pages/authoring-conversation';
import MyCreations from '~/pages/my-creations.vue';
import UserImages from '~/pages/user-images.vue';
import { rememberPath } from '~/router-history';
import { trackAreaViewed } from '~/telemetry/usePostHog';

const routes = [
  //  TODO transform the routes in named routes
  // TODO Routes from constants need adjusted to contain the name of the routes
  {
    path: Routes.Home,
    component: Home,
  },
  {
    path: Routes.Authoring.path,
    name: Routes.Authoring.name,
    meta: { area: 'author' },
    component: AuthoringConversation,
    beforeEnter: [authGuard, authMiddleware],
  },
  {
    path: Routes.Conversation.path,
    name: Routes.Conversation.name,
    // Discover is the display name of the assist page; it has no route of its own.
    meta: { area: 'discover' },
    component: Conversation,
    beforeEnter: [authGuard, authMiddleware],
  },
  { path: Routes.Callback, component: Callback },
  { path: Routes.Dashboard, component: Dashboard, beforeEnter: [authGuard, authMiddleware] },
  { path: Routes.Login, component: Login },
  {
    path: '/:pathMatch(.*)*/:statusCode',
    name: 'Error',
    component: Error,
    props: true,
  },
  {
    path: Routes.MyCreations,
    component: MyCreations,
    name: Routes.MyCreations,
    beforeEnter: [authGuard, authMiddleware],
  },
  {
    path: Routes.UserImages,
    component: UserImages,
    name: Routes.UserImages,
    beforeEnter: [authGuard, authMiddleware],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach((to, from, failure) => {
  if (to.name === Routes.Authoring.name || to.name === Routes.Conversation.name) {
    rememberPath(to.name, to.fullPath);
  }

  // `area-viewed` fires when the user enters a screen, not on every navigation
  // inside it: moving from /assist to /assist/:conversationId keeps the same
  // area, so it is not a new view.
  if (!failure && to.meta.area && to.meta.area !== from.meta.area) {
    trackAreaViewed(to.meta.area);
  }
});

export default router;
